import { render, staticRenderFns } from "./PasswordRecovery.vue?vue&type=template&id=e49110a6&scoped=true&"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecovery.vue?vue&type=style&index=0&id=e49110a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49110a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e49110a6')) {
      api.createRecord('e49110a6', component.options)
    } else {
      api.reload('e49110a6', component.options)
    }
    module.hot.accept("./PasswordRecovery.vue?vue&type=template&id=e49110a6&scoped=true&", function () {
      api.rerender('e49110a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/PasswordRecovery.vue"
export default component.exports